module.exports = __webpack_public_path__ + "img/ZB52_05.cb3e39fc.jpg";